import {
  Button,
  FormGroup,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import {
  Container,
  ContainerForm,
  ContainerFormRight,
  Title,
} from "../../styles/index.sty";
import AlertSnack from "../../components/Alert/AlertSnack";
import { useAuth } from "../../context/authContext";
import { useLists } from "../../context/listContext";
import {
  insertProductSubCategoryData,
  updateProductSubCategoryData,
} from "../../api/product-sub-categories.api";
import { useEffect } from "react";

export const AddProductSubCategory = () => {
  const { config2 } = useAuth();
  const {
    fetchProductSubCategoriesList,
    productCategoriesBarList,
    productCategoriesByBarList,
    fetchProductCategoriesByBarList,
    fetchProductCategoriesBarList,
  } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const prodSubCat = location?.state?.data;
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [product_category_id, setProducy_category_id] = useState(
    prodSubCat?.product_category_id
  );
  const [product_category_bar_id, setProducy_category_bar_id] = useState(
    prodSubCat?.product_category_bar_id
  );
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState({});
  useEffect(() => {
    fetchProductCategoriesByBarList(prodSubCat?.product_category_bar_id);
    fetchProductCategoriesBarList();
  }, [location]);
  const formik = useFormik({
    initialValues: {
      product_sub_category_name: prodSubCat?.product_sub_category_name,
      product_sub_category_description:
        prodSubCat?.product_sub_category_description,
    },
    onSubmit: async (values) => {
      setLoading(true);
      if (prodSubCat) {
        const submit = await updateProductSubCategoryData(
          {
            ...values,
            file,
            image_name: prodSubCat.product_category_bar_image_name,
            product_category_bar_id,
            product_sub_category_id: prodSubCat?.product_sub_category_id,
            product_category_id,
          },
          config2
        );
        setResponse(submit);
        setOpen(true);
        fetchProductSubCategoriesList();
        if (submit.status === "success") {
          navigate("/product-sub-categories");
        }
      } else {
        const submit = await insertProductSubCategoryData(
          { ...values, file, product_category_bar_id, product_category_id },
          config2
        );
        setResponse(submit);
        fetchProductSubCategoriesList();
        setOpen(true);
        if (submit.status === "success") {
          navigate("/product-sub-categories");
        }
      }
    },
  });

  return (
    <>
      <Container>
        <Title variant="h5" className="w-[100%]">
          Enter Product Sub Category Details.
        </Title>
        <ContainerForm>
          {open && (
            <AlertSnack
              open={open}
              setOpen={setOpen}
              response={response}
              setLoading={setLoading}
              route="customers"
            />
          )}

          {loading ? (
            <div className="items-center">
              <BeatLoader color="#36d7b7" />
            </div>
          ) : (
            <div style={{ width: "60%", margin: "auto" }}>
              <FormGroup>
                <InputLabel id="demo-simple-select-label">
                  Product Category Bar:<span className='text-[red]'>** </span>
                </InputLabel>
                <Select
                  id="demo-simple-select"
                  value={product_category_bar_id}
                  style={{ textAlign: "left" }}
                  onChange={(e) => {
                    setProducy_category_bar_id(e.target.value);
                    fetchProductCategoriesByBarList(e.target.value);
                  }}
                >
                  {productCategoriesBarList.map((bar) => {
                    return (
                      <MenuItem
                        value={bar.product_category_bar_id}
                        key={bar.product_category_bar_id}
                      >
                        {bar.product_category_bar_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormGroup>
              <br />
              <FormGroup>
                <InputLabel id="demo-simple-select-label">
                  Product Category:<span className='text-[red]'>** </span>
                </InputLabel>
                <Select
                  id="demo-simple-select"
                  value={product_category_id}
                  style={{ textAlign: "left" }}
                  onChange={(e) => {
                    setProducy_category_id(e.target.value);
                  }}
                >
                  {productCategoriesByBarList.map((cat) => {
                    return (
                      <MenuItem value={cat.product_category_id}>
                        {cat.product_category_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormGroup>
              <br />
              <FormGroup>
                <InputLabel htmlFor="product_sub_category_name">
                  Product Sub Category Name:{" "}<span className='text-[red]'>** </span>
                </InputLabel>
                <OutlinedInput
                  name="product_sub_category_name"
                  placeholder="Enter Product Category Name"
                  id="product_sub_category_name"
                  type="text"
                  value={formik.values.product_sub_category_name}
                  onChange={formik.handleChange}
                />
              </FormGroup>
              <br />
              <FormGroup>
                <InputLabel htmlFor="product_sub_category_description">
                  Product Sub Category Description:{" "}
                </InputLabel>
                <OutlinedInput
                  name="product_sub_category_description"
                  placeholder="Enter Product Category Description"
                  id="product_sub_category_description"
                  type="text"
                  value={formik.values.product_sub_category_description}
                  onChange={formik.handleChange}
                />
              </FormGroup>
              <br />
              <FormGroup>
                <InputLabel htmlFor="file">Sub Category Image:<span className='text-[red]'>** </span> </InputLabel>
                <OutlinedInput
                  name="file"
                  placeholder="Select Image"
                  id="file"
                  type="file"
                  // value={file}
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </FormGroup>
              <div className="flex flex-row justify-between">
                <Button
                  type="button"
                  variant="contained"
                  color="info"
                  onClick={() => navigate("/product-sub-categories")}
                  style={{
                    marginTop: "1rem",
                    width: "48%",
                  }}
                >
                  Back
                </Button>
                <Button
                  type="button"
                  variant="contained"
                  color="info"
                  onClick={formik.handleSubmit}
                  style={{
                    marginTop: "1rem",
                    width: "48%",
                  }}
                >
                  Save & Continue
                </Button>
              </div>
              {/* <Button
          fullWidth
          type="button"
          variant='contained'
          color='info'
          onClick={logList}
          style={{
            margin: "1rem auto"
          }}
          >
          Click Me TO Check
        </Button> */}
            </div>
          )}
        </ContainerForm>
        <ContainerFormRight>
          <div className="flex flex-wrap">
            <p className="text-2xl mb-4 w-[100%]">
              <b>Image Preview</b>
            </p>
            <hr />
            {location?.pathname.includes("update") ? (
              <div className="w-[50%] mb-12">
                <p className="text-xl mb-4">
                  <b>Old Image</b>
                </p>
                <img
                  className=" m-auto"
                  src={prodSubCat?.product_sub_category_image_file}
                  alt={prodSubCat?.product_sub_category_image_name}
                />
              </div>
            ) : null}
            <div className="w-[50%]">
              <p className="text-xl mb-4">
                <b>New Image</b>
              </p>
              {file ? (
                <img
                  className=" m-auto"
                  src={URL.createObjectURL(file)}
                  alt={prodSubCat?.product_sub_category_image_name}
                />
              ) : (
                <p>No Image Selected</p>
              )}
            </div>
          </div>
        </ContainerFormRight>
      </Container>
    </>
  );
};
